import { categoryList } from "@/mocks/anime";

export default function Categories() {
  return (
    <section id="categories" className="relative py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-semibold px-4 py-1.5 mb-4">
            <i className="ri-folder-open-line"></i>
            按口味逛
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950">动漫分类</h2>
          <p className="mt-3 md:mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            从题材出发，走进属于你的番剧世界。选一个心动的分类，缘分就从这里开始。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {categoryList.map((c) => (
            <button
              key={c.name}
              type="button"
              onClick={() => {
                document.querySelector("#popular")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group text-left rounded-2xl bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-xl text-foreground-950">{c.name}</h3>
              <p className="mt-1 text-xs text-foreground-600">{c.desc}</p>
              <p className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                <i className="ri-archive-2-line"></i>
                {c.count} 部
                <i className="ri-arrow-right-line ml-1"></i>
              </p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}